import React from 'react';
import { useAtom } from 'jotai';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { powertrainAtom, type Powertrain } from 'atoms/powertrainAtom';
import { POWERTRAIN_COLORS } from 'styles/theme';

// BEV/HEV トグル。セッション全体のモード（HEV対応仕様 §2.1）。現行ロジックを維持し見た目のみ刷新。
export const PowertrainToggle: React.FC = () => {
    const [powertrain, setPowertrain] = useAtom(powertrainAtom);

    return (
        <ToggleButtonGroup
            size="small"
            exclusive
            value={powertrain}
            onChange={(_, value) => {
                // exclusive では選択中ボタンの再クリックで null になるため、その場合は無視する。
                if (value) setPowertrain(value as Powertrain);
            }}
            aria-label="パワートレイン切替"
            sx={{ bgcolor: 'background.paper', borderRadius: 2, flexShrink: 0 }}
        >
            {/* 選択状態はテーマ非依存の固定色。BEV/HEV で別色（履歴 Chip と同一色）。 */}
            <ToggleButton
                value="bev"
                aria-label="BEV"
                title="BEV"
                sx={{
                    '&.Mui-selected': {
                        bgcolor: POWERTRAIN_COLORS.bev.main,
                        color: POWERTRAIN_COLORS.bev.contrast,
                    },
                    '&.Mui-selected:hover': { bgcolor: POWERTRAIN_COLORS.bev.hover },
                }}
            >
                BEV
            </ToggleButton>
            <ToggleButton
                value="hev"
                aria-label="HEV"
                title="HEV"
                sx={{
                    '&.Mui-selected': {
                        bgcolor: POWERTRAIN_COLORS.hev.main,
                        color: POWERTRAIN_COLORS.hev.contrast,
                    },
                    '&.Mui-selected:hover': { bgcolor: POWERTRAIN_COLORS.hev.hover },
                }}
            >
                HEV
            </ToggleButton>
        </ToggleButtonGroup>
    );
};
